import React, { FC } from 'react';
import Typo from '../Typography/Typo';
import { ReadMoreContainer } from '../ReadMore/ReadMoreContainer';

type TTerritoryDetailsDescriptionProps = {
  description: string;
};

export const TerritoryDetailsDescription: FC<TTerritoryDetailsDescriptionProps> = ({ description }) => {
  if (!description) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      <Typo variant="small-p" className="!text-xs text-t2-neutral-grey06">
        About
      </Typo>
      <ReadMoreContainer>{description}</ReadMoreContainer>
    </div>
  );
};
